(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/module/assets/javascripts/load.js') >= 0) return;  svs.modules.push('/components/core/module/assets/javascripts/load.js');
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _module = svs.core.module;
var helpers = svs.core.module.helpers;
var loadAndCache = function loadAndCache(url, callback, silentLoad, invalidateCache) {
  if (invalidateCache) {
    helpers.cache.clearCacheByKey(url);
  }
  var cacheData = helpers.cache.getFromCache(url);
  if (cacheData) {
    helpers.logger.debug("".concat(url, " found in module cache"));
    if (cacheData.init) {
      eval(cacheData.init);
    }
    if (callback) {
      callback(null, cacheData);
    }
  } else {
    helpers.logger.debug("".concat(url, " NOT found in module cache, load from server"));
    $.getJSON(url, function (data) {
      helpers.loadStyles(data.styles);
      if (data.data) {
        $.extend(true, svs, data.data);
      }
      helpers.loadScripts(data.scripts, function () {
        if (!silentLoad && data.init) {
          eval(data.init);
        }
        helpers.cache.storeInCache(url, data);
        if (callback) {
          callback(null, data);
        }
      });
    }).fail(callback);
  }
};

_module.load = function (url, htmlFn, callback) {
  var urlArg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var silentLoad = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var invalidateCache = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (urlArg) {
    return _module.filter.getAssets(url, urlArg, callback);
  }
  if (url.indexOf('/cl/') === 0) {
    url = "/_".concat(svs.core.config.data.svsconfig.tribe).concat(url);
  }
  if (url.indexOf('json=true') < 0) {
    url += '?json=true';
  }
  url += '&v=2';
  loadAndCache(url, callback, silentLoad, invalidateCache);
};

_module.loadModuleComponent = function (component, callback) {
  var silentLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var invalidCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var typeofCallback = _typeof(callback);
  if (typeofCallback !== 'function') {
    throw new Error("Expected param `callback` to be a function. Received: `".concat(typeofCallback, "`"));
  }
  var url = "/_".concat(svs.core.config.data.svsconfig.tribe, "/mcl/").concat(svs.core.data.module, "/").concat(component);
  loadAndCache(url, callback, silentLoad, invalidCache);
};

 })(window);